import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../shared/profile.service';
import { map } from 'rxjs/operators';
import { Country, TOOLS_UNSUPPORTED_COUNTRIES } from '../../shared/types/countries';

@Component({
  selector: 'lp2-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss'],
  providers: [NgbTabsetConfig]
})
export class ToolsComponent {
  @ViewChild('tabs') tabs: ElementRef;
  @ViewChild('container') container: ElementRef;

  showTranslator$ = this.profileService.address$.pipe(map(({countryISO}) => !TOOLS_UNSUPPORTED_COUNTRIES.includes(countryISO as Country)));

  constructor(config: NgbTabsetConfig, private readonly profileService: ProfileService) {
    config.justify = 'center';
  }

}



// WEBPACK FOOTER //
// ./ts/app/footer/tools/tools.component.ts